module.exports = __webpack_public_path__ + "img/jr55.1bb48fc5.jpg";